import * as React from 'react';
import { toggleEmailListSubscription } from '@/redux/modules/account/notifications/emailList/emailList.actions';
import { UNSUBSCRIBE_TO_ALL_EMAIL_LISTS } from '@/redux/modules/account/notifications/emailList/emailList.types';
import { useAppDispatch } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import Checkbox from '@liveauctioneers/caterwaul-components/lib/Checkbox/Checkbox';
import styled, { useTheme } from 'styled-components';
import TableRow from './TableRow';
import Text, { BodySecondary } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import useWindowSize from '@/hooks/useWindowSize';

type Props = {
    code: string;
    description: string;
    frequency: string;
    name: string;
    subscribed: boolean;
};

const NotificationRow = ({ code, description, frequency, name, subscribed }: Props) => {
    const { formatMessage } = useIntl();
    const dispatch = useAppDispatch();
    const frequencyText = frequency === 'Real Time' ? 'Real-Time' : frequency;
    const toggleEmail = React.useCallback(() => {
        dispatch(toggleEmailListSubscription({ code }));
    }, [code, dispatch]);

    const { width } = useWindowSize();
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = useTheme();

    if (code === UNSUBSCRIBE_TO_ALL_EMAIL_LISTS) {
        return null;
    }

    return (
        <StyledTableRow
            email={
                <StyledCheckbox
                    checked={subscribed}
                    label={formatMessage({ id: 'notificationsPage.toggleEmailNotifcations' }, { name })}
                    labelDisplay=""
                    name="emailCheckbox"
                    onClick={toggleEmail}
                />
            }
            frequency={width > tabletNarrowWidthNum && <BodySecondary>{frequencyText}</BodySecondary>}
            type={
                <>
                    <Text
                        h5={width > tabletNarrowWidthNum}
                        h6={width <= tabletNarrowWidthNum}
                    >
                        {name}
                    </Text>
                    <Text
                        caption={width <= tabletNarrowWidthNum}
                        colorPrimaryWeak
                        secondary={width > tabletNarrowWidthNum}
                    >
                        {description}
                    </Text>
                </>
            }
        />
    );
};

const StyledTableRow = styled(TableRow)`
    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        > :nth-child(1) {
            grid-column: 1 / 5;
        }
    }
`;

export default React.memo<Props>(NotificationRow);

const StyledCheckbox = styled(Checkbox)`
    margin-bottom: 0;
`;
